import once from '@lib/once';

window.Drupal.behaviors.headerSearch = {
    attach: (context) => {
        const headerSearch = context.querySelector('#header-search');
        const mobileSearch = context.querySelector('#mobile-search');

        once(
            'headerSearch',
            () => {
                mobileSearch.addEventListener('click', () => {
                    headerSearch.classList.toggle('is-visible');
                });

                document.addEventListener('click', (e) => {
                    if (mobileSearch.contains(e.target) || headerSearch.contains(e.target)) return;
                    headerSearch.classList.remove('is-visible');
                });
            },
            [headerSearch, mobileSearch]
        );
    },
};
